<script>
import BOForm from '../../baseComponents/boForm'
export default {
	extends: BOForm,
	data() {
		return {
			items: [
				{ label: 'Prénom', value: 'firstName', type: 'text', required: true },
				{ label: 'Nom', value: 'lastName', type: 'text', required: true },
				{
					label: 'Email',
					value: 'mail',
					type: 'text',
					required: true,
					rules: [
						v => {
							const pattern = /^[a-zA-Z0-9]([.\-_]?[a-zA-Z0-9])*@[a-zA-Z0-9]([.\-_]?[a-zA-Z0-9])*.[a-zA-Z]{2,4}$/
							return pattern.test(v) || 'email invalide'
						}
					]
				},
				{
					label: 'Mot de passe',
					value: 'password',
					type: 'text',
					hide: () => !!this.model._id,
					required: true,
					rules: [
						v => {
							const pattern = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/
							return (!!v && v.length > 7 && pattern.test(v)) || 'Le mot de passe doit contenir 8 caractères, dont au moins une lettre et un chiffre'
						}
					]
				},
				{
					label: 'Telephone',
					value: 'phone',
					type: 'text',
					required: false,
					rules: [
						v => {
							const pattern = /^(?:(?:\+|00)33|0)\s*[1-9](?:[\s.-]*\d{2}){4}$/
							return !v || pattern.test(v) || 'telephone invalide'
						}
					]
				}
			]
		}
	},
	methods: {
		async post() {
			await this.axios.post('proUsers', this.model)
		},
		async put() {
			await this.axios.put('proUsers/' + this.model._id, this.model)
		}
	}
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/proUsers/proUser.form.vue